module.exports = __webpack_public_path__ + "img/logo_xindongfang.75bddfbe.png";